<h5 class="title-partner">{{ 'partner.list.title' | translate }}</h5>

<div class="card bg-white font-size-14">
  <div class="row text-left details-header">
    <div class="col-10 col-lg-3 d-lg-none d-block">
      <label class="fw-bold">{{ 'partner.details' | translate }}</label>
    </div>
    <div class="col-4 d-lg-block d-none">
      <label class="fw-bold">{{ 'partner.fullname' | translate }}</label>
    </div>
    <div class="col-4 d-lg-block d-none">
      <label class="fw-bold">{{ 'partner.email' | translate }}</label>
    </div>
    <div class="col-2 d-lg-block col-status d-none" [ngClass]="{ 'ms-auto text-end': !isPendingPartner }">
      <label class="fw-bold">{{ 'partner.status' | translate }}</label>
    </div>
    <div class="col-2 ms-auto text-center" *ngIf="isPendingPartner">
      <label class="fw-bold">{{ 'partner.action' | translate }}</label>
    </div>
  </div>
  <div *ngFor="let partner of approvedPartners$ | async" class="row text-left align-items-center mt-lg-2 mt-3">
    <div class="col-lg-4 col-10 partner-info">
      <div class="pb-lg-0 pb-1">{{ partner.FullName }}</div>
      <div class="d-flex d-lg-none flex-column">
        <div class="pb-lg-0 pb-1">{{ partner.Email }}</div>
        <div class="text-success fw-bold">{{ 'partner.text' | translate }}</div>
      </div>
    </div>
    <div class="col-4 d-lg-block d-none partner-info">
      <div>{{ partner.Email }}</div>
    </div>
    <div class="col-2 d-lg-block col-status d-none partner-info" [ngClass]="{ 'ms-auto text-end': !isPendingPartner }">
      <div class="text-success fw-bold">{{ 'partner.text' | translate }}</div>
    </div>
  </div>

  <div *ngFor="let partner of pendingPartners$ | async" class="row text-left align-items-center mt-lg-2 mt-3">
    <div class="col-lg-4 col-10 partner-info">
      <div class="pb-lg-0 pb-1 text-info">{{ partner.FullName }}</div>
      <div class="d-flex d-lg-none flex-column">
        <div class="text-info pb-lg-0 pb-1">{{ partner.Email }}</div>
        <div class="text-infofw-bold">{{ 'pending.text' | translate }}</div>
      </div>
    </div>
    <div class="col-4 d-lg-block d-none partner-info">
      <div class="text-info">{{ partner.Email }}</div>
    </div>
    <div class="col-2 d-lg-block col-status d-none partner-info">
      <div class="text-info fw-bold">{{ 'pending.text' | translate }}</div>
    </div>
    <div class="col-2 partner-info ms-auto text-center">
      <span
        class="text-info font-size-24 material-icons cursor-pointer"
        confirmModal
        [confirmContent]="confirmContent"
        [confirmContext]="partner"
        (confirm)="deletePending(partner.TicketKey)"
        (click)="selectPartner(partner.FullName, partner.Email)"
      >
        delete_forever
      </span>
    </div>
  </div>
  <ng-container
    *ngIf="{
      approvedPartners: approvedPartners$ | async,
      pendingPartners: pendingPartners$ | async,
    } as pt"
  >
    <ng-container *ngIf="!pt.approvedPartners.length && !pt.pendingPartners.length">
      <div class="text-center pt-3 font-size-14">{{ 'no.partner.placeholder' | translate }}</div>
    </ng-container>
  </ng-container>
</div>

<ng-template #confirmContent>
  <div class="partner-list-modal-header">
    <h5 class="mb-0">{{ 'partner.list.modal.delete.title' | translate }}</h5>
  </div>
  <div class="partner-list-modal-body">
    <p class="mb-2">{{ 'partner.list.modal.delete.message' | translate }}</p>
    <div class="partner-info">
      <span class="partner-name fw-bold me-1">{{ partnerName }}</span>
      <span class="partner-email">({{ partnerEmail }})</span>
    </div>
  </div>
</ng-template>
